import type { IExercise } from '../exercises';

export const ARCHIVED_SHOULDERS_TEACHINGS: IExercise[] = [
  {
    "id": "prone-dumbbell-fly",
    "name": "俯卧哑铃飞鸟",
    "bodyPart": "shoulders",
    "equipment": "dumbbell",
    "subCategory": "rear-deltoid",
    "tips": ["核心收紧，控制动作节奏","全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["三角肌后束","斜方肌下部"],
    "demoUrl": "/media/gifs/prone-dumbbell-fly",
    "videoUrl": "/media/videos/prone-dumbbell-fly",
  },
  {
    "id": "band-shoulder-pull",
    "name": "弹力带肩部前后拉",
    "bodyPart": "shoulders",
    "equipment": "resistance-band",
    "subCategory": "shoulder",
    "tips": ["核心收紧，控制动作节奏","全程保持肩胛骨稳定"],
    "sets": 2,
    "reps": "15",
    "rpe": 4,
    "restSeconds": 30,
    "isBodyweight": false,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "demoUrl": "/media/gifs/band-shoulder-pull",
    "videoUrl": "/media/videos/band-shoulder-pull",
  },
  {
    "id": "cable-face-pull",
    "name": "绳索面拉",
    "bodyPart": "shoulders",
    "equipment": "cable",
    "subCategory": "rear-deltoid",
    "tips": ["核心收紧，控制动作节奏","全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["三角肌后束","斜方肌下部"],
    "demoUrl": "/media/gifs/cable-face-pull",
    "videoUrl": "/media/videos/cable-face-pull",
  },
  {
    "id": "home-prone-reverse-fly",
    "name": "俯卧反向飞鸟",
    "bodyPart": "shoulders",
    "equipment": "dumbbell",
    "subCategory": "rear-deltoid",
    "tips": ["核心收紧，控制动作节奏","全程保持肩胛骨稳定"],
    "sets": 2,
    "reps": "15",
    "rpe": 4,
    "restSeconds": 30,
    "isBodyweight": false,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["三角肌后束","斜方肌下部"],
    "demoUrl": "/media/gifs/home-prone-reverse-fly",
    "videoUrl": "/media/videos/home-prone-reverse-fly",
  },
  {
    "id": "home-wall-handstand",
    "name": "靠墙倒立",
    "bodyPart": "shoulders",
    "equipment": "bodyweight",
    "subCategory": "front-deltoid",
    "tips": ["核心收紧，控制动作节奏","全程保持稳定"],
    "sets": 3,
    "reps": "30秒",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": true,
    "difficulty": "advanced",
    "targetMuscles": ["三角肌前束","三角肌中束"],
    "demoUrl": "/media/gifs/home-wall-handstand",
    "videoUrl": "/media/videos/home-wall-handstand",
  },
  {
    "id": "home-prone-y-raise",
    "name": "俯卧Y字举",
    "bodyPart": "shoulders",
    "equipment": "bodyweight",
    "subCategory": "rear-deltoid",
    "tips": ["核心收紧，控制动作节奏","全程保持肩胛骨稳定"],
    "sets": 2,
    "reps": "15",
    "rpe": 4,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["三角肌后束","斜方肌下部"],
    "demoUrl": "/media/gifs/home-prone-y-raise",
    "videoUrl": "/media/videos/home-prone-y-raise",
  },
  {
    "id": "home-seated-dumbbell-rear-fly",
    "name": "坐姿哑铃俯身飞鸟",
    "bodyPart": "shoulders",
    "equipment": "dumbbell",
    "subCategory": "rear-deltoid",
    "tips": ["核心收紧，控制动作节奏","全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["三角肌后束","斜方肌下部"],
    "demoUrl": "/media/gifs/home-seated-dumbbell-rear-fly",
    "videoUrl": "/media/videos/home-seated-dumbbell-rear-fly",
  },
  {
    "id": "home-seated-dumbbell-press",
    "name": "坐姿哑铃推举",
    "bodyPart": "shoulders",
    "equipment": "dumbbell",
    "subCategory": "front-deltoid",
    "tips": ["核心收紧，控制动作节奏","全程保持肩胛骨稳定"],
    "sets": 4,
    "reps": "8-12",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["三角肌前束","三角肌中束"],
    "demoUrl": "/media/gifs/home-seated-dumbbell-press",
    "videoUrl": "/media/videos/home-seated-dumbbell-press",
  },
  {
    "id": "ksw-y-raise",
    "name": "Y字侧平举",
    "bodyPart": "shoulders",
    "equipment": "bodyweight",
    "subCategory": "rear-deltoid",
    "tips": ["俯身或俯卧，手臂呈Y字展开","用三角肌后束发力，10次+10次递减组"],
    "sets": 3,
    "reps": "10+10",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": true,
    "difficulty": "advanced",
    "targetMuscles": ["三角肌后束","斜方肌下部"],
    "source": "凯圣王合集",
    "demoUrl": "/media/gifs/ksw-y-raise",
    "videoUrl": "/media/videos/ksw-y-raise",
  },
  {
    "id": "ksw-warmup-thoracic-proprioception",
    "name": "胸椎本体感受激活",
    "bodyPart": "shoulders",
    "equipment": "bodyweight",
    "subCategory": "激活",
    "tips": ["配合呼吸做胸椎旋转+稳定","提升胸椎本体感受，减少腰背代偿"],
    "sets": 2,
    "reps": "10",
    "rpe": 2,
    "restSeconds": 20,
    "isBodyweight": true,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "凯圣王合集",
    "demoUrl": "/media/gifs/ksw-warmup-thoracic-proprioception",
    "videoUrl": "/media/videos/ksw-warmup-thoracic-proprioception",
  },
  {
    "id": "threeway-shoulder-warmup",
    "name": "肩部热身",
    "bodyPart": "shoulders",
    "equipment": "bodyweight",
    "subCategory": "shoulder",
    "tips": ["肩部环绕激活肩袖肌群","前后各10圈"],
    "sets": 2,
    "reps": "15次",
    "rpe": 5,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "demoUrl": "/media/videos/threeway-shoulder-warmup",
    "videoUrl": "/media/videos/threeway-shoulder-warmup",
  },
  {
    "id": "threeway-lateral-raise",
    "name": "侧平举",
    "bodyPart": "shoulders",
    "equipment": "dumbbell",
    "subCategory": "side-deltoid",
    "tips": ["肘部微屈","举至与肩同高"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": false,
    "demoUrl": "/media/videos/threeway-lateral-raise",
    "videoUrl": "/media/videos/threeway-lateral-raise",
  },
  {
    "id": "threeway-seated-reverse-fly",
    "name": "坐姿反飞鸟",
    "bodyPart": "shoulders",
    "equipment": "machine",
    "subCategory": "rear-deltoid",
    "tips": ["肩胛骨后缩","感受后束收缩"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": false,
    "demoUrl": "/media/videos/threeway-seated-reverse-fly",
    "videoUrl": "/media/videos/threeway-seated-reverse-fly",
  },
  {
    "id": "threeway-cable-reverse-fly",
    "name": "对握反飞鸟",
    "bodyPart": "shoulders",
    "equipment": "cable",
    "subCategory": "rear-deltoid",
    "tips": ["手肘微屈","绳索从身前向两侧打开"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": false,
    "demoUrl": "/media/videos/threeway-cable-reverse-fly",
    "videoUrl": "/media/videos/threeway-cable-reverse-fly",
  },
  {
    "id": "threeway-dumbbell-shoulder-activation",
    "name": "哑铃肩激活",
    "bodyPart": "shoulders",
    "equipment": "dumbbell",
    "subCategory": "shoulder",
    "tips": ["轻重量多组数激活","侧平举+前平举组合"],
    "sets": 2,
    "reps": "15次",
    "rpe": 5,
    "restSeconds": 30,
    "isBodyweight": false,
    "isWarmup": true,
    "demoUrl": "/media/videos/threeway-dumbbell-shoulder-activation",
    "videoUrl": "/media/videos/threeway-dumbbell-shoulder-activation",
  },
  {
    "id": "threeway-smith-press",
    "name": "史密斯实力推",
    "bodyPart": "shoulders",
    "equipment": "machine",
    "subCategory": "front-deltoid",
    "tips": ["史密斯轨迹稳定","推至头顶不锁肘"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/videos/threeway-smith-press",
    "videoUrl": "/media/videos/threeway-smith-press",
  },
  {
    "id": "personal-s1-posterior-delt-stretch",
    "name": "三角肌后束拉伸",
    "bodyPart": "shoulders",
    "equipment": "bodyweight",
    "subCategory": "shoulder",
    "tips": ["肩膀下沉不耸肩","每侧保持30-60秒"],
    "sets": 2,
    "reps": "45秒",
    "rpe": 2,
    "restSeconds": 10,
    "isBodyweight": true,
    "isStretch": true,
    "isWarmup": true,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s1-posterior-delt-stretch",
    "videoUrl": "/media/videos/personal-s1-posterior-delt-stretch",
  },
  {
    "id": "personal-s1-anterior-delt-stretch",
    "name": "三角肌前束拉伸",
    "bodyPart": "shoulders",
    "equipment": "bodyweight",
    "subCategory": "shoulder",
    "tips": ["核心收紧不塌腰","每侧保持30-60秒"],
    "sets": 2,
    "reps": "45秒",
    "rpe": 2,
    "restSeconds": 10,
    "isBodyweight": true,
    "isStretch": true,
    "isWarmup": true,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s1-anterior-delt-stretch",
    "videoUrl": "/media/videos/personal-s1-anterior-delt-stretch",
  },
  {
    "id": "personal-s2-cable-reverse-fly",
    "name": "龙门架反向飞鸟",
    "bodyPart": "shoulders",
    "equipment": "cable",
    "subCategory": "rear-delt",
    "tips": ["俯身角度稳定","感受后束挤压"],
    "sets": 3,
    "reps": "15",
    "rpe": 7,
    "restSeconds": 45,
    "isBodyweight": false,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s2-cable-reverse-fly",
    "videoUrl": "/media/videos/personal-s2-cable-reverse-fly",
  },
  {
    "id": "personal-s4-shoulder-work",
    "name": "肩部训练",
    "bodyPart": "shoulders",
    "equipment": "dumbbell",
    "subCategory": "medial-delt",
    "tips": ["作为胸部训练收尾","侧平举中束刺激"],
    "sets": 3,
    "reps": "12",
    "rpe": 7,
    "restSeconds": 60,
    "isBodyweight": false,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s4-shoulder-work",
    "videoUrl": "/media/videos/personal-s4-shoulder-work",
  },
  {
    "id": "personal-s5-trx-activation",
    "name": "Trx激活",
    "bodyPart": "shoulders",
    "equipment": "trx",
    "subCategory": "shoulder",
    "tips": ["激活肩胛稳定肌","动作匀速控制"],
    "sets": 2,
    "reps": "12",
    "rpe": 4,
    "restSeconds": 30,
    "isBodyweight": false,
    "isWarmup": true,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s5-trx-activation",
    "videoUrl": "/media/videos/personal-s5-trx-activation",
  },
  {
    "id": "personal-s5-bent-over-rear-delt",
    "name": "俯身哑铃肩伸后束",
    "bodyPart": "shoulders",
    "equipment": "dumbbell",
    "subCategory": "rear-delt",
    "tips": ["俯身角度稳定不晃","感受后束挤压"],
    "sets": 3,
    "reps": "15",
    "rpe": 7,
    "restSeconds": 45,
    "isBodyweight": false,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s5-bent-over-rear-delt",
    "videoUrl": "/media/videos/personal-s5-bent-over-rear-delt",
  },
  {
    "id": "personal-s5-dumbbell-shoulder-press",
    "name": "哑铃推肩",
    "bodyPart": "shoulders",
    "equipment": "dumbbell",
    "subCategory": "anterior-delt",
    "tips": ["核心收紧不顶腰","推至头顶正上方"],
    "sets": 3,
    "reps": "10",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s5-dumbbell-shoulder-press",
    "videoUrl": "/media/videos/personal-s5-dumbbell-shoulder-press",
  },
  {
    "id": "personal-s5-lateral-raise",
    "name": "哑铃侧平举中束",
    "bodyPart": "shoulders",
    "equipment": "dumbbell",
    "subCategory": "medial-delt",
    "tips": ["肘微屈，侧抬与肩齐平","控制下放"],
    "sets": 3,
    "reps": "15",
    "rpe": 7,
    "restSeconds": 45,
    "isBodyweight": false,
    "source": "私教版",
    "demoUrl": "/media/gifs/personal-s5-lateral-raise",
    "videoUrl": "/media/videos/personal-s5-lateral-raise",
  },
  {
    "id": "fanjue-elbow-bench-stretch",
    "name": "手肘搭平板凳",
    "bodyPart": "shoulders",
    "equipment": "bodyweight",
    "subCategory": "thoracic",
    "tips": ["胸椎旋转活动","每侧保持30秒"],
    "sets": 2,
    "reps": "15次",
    "rpe": 4,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "demoUrl": "/media/gifs/fanjue-elbow-bench-stretch",
    "videoUrl": "/media/videos/fanjue-elbow-bench-stretch",
  },
  {
    "id": "fanjue-external-rotation-press",
    "name": "外旋位推肩",
    "bodyPart": "shoulders",
    "equipment": "bodyweight",
    "subCategory": "shoulder",
    "tips": ["外旋位启动","激活肩袖肌群"],
    "sets": 2,
    "reps": "15次",
    "rpe": 5,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "demoUrl": "/media/gifs/fanjue-external-rotation-press",
    "videoUrl": "/media/videos/fanjue-external-rotation-press",
  },
  {
    "id": "fanjue-head-ground-press",
    "name": "头枕地对抗",
    "bodyPart": "shoulders",
    "equipment": "bodyweight",
    "subCategory": "thoracic",
    "tips": ["仰卧头轻压地面","深层颈屈肌激活"],
    "sets": 2,
    "reps": "15次",
    "rpe": 4,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "demoUrl": "/media/gifs/fanjue-head-ground-press",
    "videoUrl": "/media/videos/fanjue-head-ground-press",
  },
  {
    "id": "fanjue-foam-roller-support",
    "name": "泡沫轴支撑",
    "bodyPart": "shoulders",
    "equipment": "foam-roller",
    "subCategory": "thoracic",
    "tips": ["胸椎段泡沫轴放松","上下滚动"],
    "sets": 2,
    "reps": "15次",
    "rpe": 4,
    "restSeconds": 30,
    "isBodyweight": false,
    "isWarmup": true,
    "demoUrl": "/media/gifs/fanjue-foam-roller-support",
    "videoUrl": "/media/videos/fanjue-foam-roller-support",
  },
  {
    "id": "fanjue-rear-delt-bodyweight",
    "name": "三角肌后束",
    "bodyPart": "shoulders",
    "equipment": "bodyweight",
    "subCategory": "rear-deltoid",
    "tips": ["俯卧位后束收缩","顶峰保持1秒"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": true,
    "demoUrl": "/media/gifs/fanjue-rear-delt-bodyweight",
    "videoUrl": "/media/videos/fanjue-rear-delt-bodyweight",
  },
  {
    "id": "fanjue-internal-rotation-activation",
    "name": "内旋肌激活",
    "bodyPart": "shoulders",
    "equipment": "bodyweight",
    "subCategory": "shoulder",
    "tips": ["肩内旋肌群激活","改善圆肩体态"],
    "sets": 2,
    "reps": "15次",
    "rpe": 5,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "demoUrl": "/media/gifs/fanjue-internal-rotation-activation",
    "videoUrl": "/media/videos/fanjue-internal-rotation-activation",
  },
  {
    "id": "fanjue-supine-face-pull",
    "name": "仰卧面拉",
    "bodyPart": "shoulders",
    "equipment": "cable",
    "subCategory": "shoulder",
    "tips": ["仰卧位面拉","后束与肩袖激活"],
    "sets": 2,
    "reps": "15次",
    "rpe": 5,
    "restSeconds": 30,
    "isBodyweight": false,
    "isWarmup": true,
    "demoUrl": "/media/gifs/fanjue-supine-face-pull",
    "videoUrl": "/media/videos/fanjue-supine-face-pull",
  },
  {
    "id": "fanjue-standing-military-press",
    "name": "实力推",
    "bodyPart": "shoulders",
    "equipment": "barbell",
    "subCategory": "front-deltoid",
    "tips": ["核心收紧","推举至头顶"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/gifs/fanjue-standing-military-press",
    "videoUrl": "/media/videos/fanjue-standing-military-press",
  },
  {
    "id": "fanjue-dumbbell-front-raise",
    "name": "哑铃前平举",
    "bodyPart": "shoulders",
    "equipment": "dumbbell",
    "subCategory": "front-deltoid",
    "tips": ["前平举刺激前束","交替或双手"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": false,
    "demoUrl": "/media/gifs/fanjue-dumbbell-front-raise",
    "videoUrl": "/media/videos/fanjue-dumbbell-front-raise",
  },
];
